<div class="loading" *ngIf="loadingStatus.isLoading | async"></div>
